import Request from '@/utils/request'

// midR充值
export function repurchaseMidRActCfg () {
  return Request({
    url: `/api/v2/app/shop/activity/13/cfg`,
    method: "get"
  });
}

// midR充值
export function repurchaseMidRActClaim (rewardId) {
  return Request({
    url: `/api/v2/app/shop/activity/13/reward/${rewardId}`,
    method: "put"
  });
}

// topR充值
export function repurchaseTopRActCfg () {
  return Request({
    url: `/api/v2/app/shop/activity/14/cfg`,
    method: "get"
  });
}

// topR充值
export function repurchaseTopRActClaim (rewardId) {
  return Request({
    url: `/api/v2/app/shop/activity/14/reward/${rewardId}`,
    method: "put"
  });
}